import * as types from '../constants/ActionTypes'

const initalState = {
  form: {},
  selectData: {},
}

const master = (state = initalState, action) => {

  switch (action.type) {
    case types.REDUCER_SYSTEMCONTROLL_ROUMU_INIT:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export default master


// WEBPACK FOOTER //
// ./src/reducers/systemControll.js